
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Carousel, CarouselItem } from 'element-ui'
import { BannerManageImpl } from '@/commons/bannerManage'
import { BannerService } from '@/commons/bannerService'
import PosterImage from '@/components/MobilePosterImage.vue'
// import News3 from '@/pages/index/components/News3.vue'
import News4 from '@/pages/index/components/News4.vue'
import instance from '@/service'
import { NewsMixinManager } from '@/pages/index/components/news-mixin/manager'
import { NewsMixinService } from '@/pages/index/components/news-mixin/service'
Vue.use(Carousel)
Vue.use(CarouselItem)
@Component({
  components: {
    PosterImage,
    // News3,
    News4
  }
})
export default class HorizontalMenu extends Vue {
  private manage = new NewsMixinManager(0, '', new NewsMixinService())
  private manager = new BannerManageImpl(new BannerService())
  private id = '77'
  private pid = 0
  // private nestitle!: []

  private swiperOptions1 = {
    // loop: true,
    autoplay: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  }

  async mounted () {
    this.manager.requestBannerList()
    // this.manager.getNewstitles()
    // this.manager.getProjectSystemInfor()
    this.manage.getNewsInfomation(this.id)
  }

  jumpdetail (item: any) {
    window.location.href = `/infoNews.html#/news/${item.id}/${'0'}`
  }

  private goLinkpage (url: string) {
    if (!url) { return }
    if (!url.includes('http://') && !url.includes('https://')) {
      url = 'https://' + url
    }
    window.open(url)
  }

  directProjcts (project: any, preId?: string) {
    const projectIds = []
    projectIds.push(project.projectSystemId)
    if (preId) {
      projectIds.push(preId)
    }
    localStorage.setItem('selectedChapter', JSON.stringify(projectIds))
    window.location.href = `/study.html#/?id=${project.projectSystemId}`
  }
}
